import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

import { StopsListDataIdentifierCommonForm } from './StopsListDataIdentifierCommonForm';

export class VerticalStopsListDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let stopsListConfiguration = {
            showOnlyInSpineStops: false,
            hideNonInSpineStops: false,
            hidePreviousStops: false,
            hideZoneLimitStops: false,
            hideStopsWithMapPoint: false,
            shrinkText: false,
            showStopCaps: false,
            showStopCode: false,
            stopCodePrecendentText: "",
            stopCodeSubsequentText: "",
            showDurations: true,
            durationBackgroundBuilderComponent: 0,
            imageOrientation: "",
            imageId: null,
            showInterfacesInSpine: true,
            interfaceOption: undefined,
            interfaceRotationAngle: undefined,
            interfaceResizeFactor: undefined,
            showPathsDescription: false,
            addSpacerStops: false,
            highlightComplementaryTerminals: false,
            stretchSpine: false,
            zonesConfig: {
                zonesPosition: "left",
                zones: [],
                zonesBackgroundBuilderComponent: 0,
            },
            showDescriptionOutsideSpine: false,
            descriptionOutsideSpine: ""
        };

        // ----------------------------

        // SelectedData parsing to support both full and zonesConfig-only
        const parseSelectedData = (dataStr) => {
            try {
                const parsed = JSON.parse(dataStr);
                if (parsed.zonesConfig && Object.keys(parsed).length === 1) {
                    // zonesConfig-only shape
                    return {
                        ...stopsListConfiguration,
                        zonesConfig: {
                            ...stopsListConfiguration.zonesConfig,
                            ...parsed.zonesConfig
                        }
                    };
                } else {
                    return {
                        ...stopsListConfiguration,
                        ...parsed
                    };
                }
            } catch (e) {
                return stopsListConfiguration;
            }
        };

        // ----------------------------

        if (this.props.selectedData !== null && this.props.selectedData !== undefined) {
            stopsListConfiguration = parseSelectedData(this.props.selectedData);
        }

        this.state = {
            form: {
                showOnlyInSpineStops: stopsListConfiguration.showOnlyInSpineStops,
                hideNonInSpineStops: stopsListConfiguration.hideNonInSpineStops,
                hidePreviousStops: stopsListConfiguration.hidePreviousStops,
                hideZoneLimitStops: stopsListConfiguration.hideZoneLimitStops,
                hideStopsWithMapPoint: stopsListConfiguration.hideStopsWithMapPoint,
                shrinkText: stopsListConfiguration.shrinkText,
                showStopCaps: stopsListConfiguration.showStopCaps,
                showStopCode: stopsListConfiguration.showStopCode,
                stopCodePrecendentText: stopsListConfiguration.stopCodePrecendentText,
                stopCodeSubsequentText: stopsListConfiguration.stopCodeSubsequentText,
                showDurations: stopsListConfiguration.showDurations || false,
                durationBackgroundBuilderComponent: stopsListConfiguration.durationBackgroundBuilderComponent,
                imageOrientation: stopsListConfiguration.imageOrientation || "",
                imageId: stopsListConfiguration.imageId || null,
                showInterfacesInSpine: stopsListConfiguration.showInterfacesInSpine || false,
                interfaceOption: stopsListConfiguration.interfaceOption || undefined,
                interfaceRotationAngle: stopsListConfiguration.interfaceRotationAngle || undefined,
                interfaceResizeFactor: stopsListConfiguration.interfaceResizeFactor || undefined,
                addSpacerStops: stopsListConfiguration.addSpacerStops || false,
                highlightComplementaryTerminals: stopsListConfiguration.highlightComplementaryTerminals || false,
                stretchSpine: stopsListConfiguration.stretchSpine,
                showPathsDescription: stopsListConfiguration.showPathsDescription || false,
                zonesConfig: stopsListConfiguration.zonesConfig || {
                    zonesPosition: stopsListConfiguration.zonesPosition || "left",
                    zones: stopsListConfiguration.zones || null,
                    zonesBackgroundBuilderComponent: stopsListConfiguration.zonesBackgroundBuilderComponent,
                },
                showDescriptionOutsideSpine: stopsListConfiguration.showDescriptionOutsideSpine || false,
                descriptionOutsideSpine: stopsListConfiguration.descriptionOutsideSpine || ""
            }
        };
    }

    // -----------------------

    onAddImage(imageId) {
        const { form } = this.state;
        form.imageId = imageId;

        this.setState({ form }, () => {
            this.onSelectData();
        });
    }

    onChangeValue(e, target) {
        const { form } = this.state;
        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    onChangeRadio = (target, value) => {
        const { form } = this.state;
        form[target] = value;

        this.setState({
            form: form
        });
    };

    onChangeCheckboxValue(target) {
        const { form } = this.state;
        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    setNestedValue(obj, path, value) {
        const parts = path.split(".");
        let current = obj;
        for (let i = 0; i < parts.length - 1; i++) {
            if (!current[parts[i]]) current[parts[i]] = {};
            current = current[parts[i]];
        }
        current[parts[parts.length - 1]] = value;
    }

    onChangeSelectValue(e, target) {
        const { form } = this.state;

        if (target.includes(".")) {
            this.setNestedValue(form, target, e);
        } else {
            form[target] = e;
        }

        this.setState({
            form: form
        });
    }

    onSelectImage(imageId) {
        const { form } = this.state;
        form.imageId = imageId;

        this.setState({
            form: form
        });
    }

    onChangeZonesValue = (zonesConfig) => {
        const { form } = this.state;
        form.zonesConfig = zonesConfig;

        this.setState({
            form: form
        });
    };

    onFinishSelectData = () => {
        const { form } = this.state;

        // stopsListConfiguration WITHOUT zonesConfig
        const {
            showOnlyInSpineStops,
            hideNonInSpineStops,
            hidePreviousStops,
            hideZoneLimitStops,
            hideStopsWithMapPoint,
            shrinkText,
            showStopCode,
            showStopCaps,
            stopCodePrecendentText,
            stopCodeSubsequentText,
            showDurations,
            durationBackgroundBuilderComponent,
            imageOrientation,
            imageId,
            showInterfacesInSpine,
            interfaceOption,
            interfaceRotationAngle,
            interfaceResizeFactor,
            showPathsDescription,
            addSpacerStops,
            highlightComplementaryTerminals,
            stretchSpine,
            showDescriptionOutsideSpine,
            descriptionOutsideSpine
        } = form;

        const stopsListConfiguration = {
            showOnlyInSpineStops,
            hideNonInSpineStops,
            hidePreviousStops,
            hideZoneLimitStops,
            hideStopsWithMapPoint,
            shrinkText,
            showStopCode,
            showStopCaps,
            stopCodePrecendentText,
            stopCodeSubsequentText,
            showDurations,
            durationBackgroundBuilderComponent,
            imageOrientation,
            imageId,
            showInterfacesInSpine,
            interfaceOption,
            interfaceRotationAngle,
            interfaceResizeFactor,
            showPathsDescription,
            addSpacerStops,
            highlightComplementaryTerminals,
            stretchSpine,
            showDescriptionOutsideSpine,
            descriptionOutsideSpine
        };

        const stopsListConfigStr = JSON.stringify(stopsListConfiguration);

        // zonesConfig ONLY
        const { zones, zonesPosition, zonesBackgroundBuilderComponent } = form.zonesConfig;

        const zonesConfigStr = JSON.stringify({
            zonesConfig: {
                zones,
                zonesPosition,
                zonesBackgroundBuilderComponent
            }
        });

        this.props.onSelectData(stopsListConfigStr, true);
        this.props.onConfigureData(zonesConfigStr, true);
    };

    // -----------------------

    render() {
        const { configuration } = this.props;
        const { form } = this.state;

        return (
            <Form>
                <StopsListDataIdentifierCommonForm
                    form={form}
                    configuration={configuration}
                    selectedData={form.imageId}
                    onChangeValue={(a, b) => this.onChangeValue(a, b)}
                    onChangeCheckboxValue={(a) => this.onChangeCheckboxValue(a)}
                    onChangeSelectValue={(a, b) => this.onChangeSelectValue(a, b)}
                    onChangeRadio={(target, value) => this.onChangeRadio(target, value)}
                    onSelectImage={(imageId) => this.onSelectImage(imageId)}
                    onAddImage={(imageId) => this.onAddImage(imageId)}
                    onChangeZonesValue={this.onChangeZonesValue}
                    onFinishSelectData={this.onFinishSelectData}
                    onCancel={this.props.onCancel} />
            </Form>
        );
    }
}
